import React from "react";

import { OrderWindow } from "./OrderWindow";
import { TabPanelContainer } from "./styled";

interface OrderWindowsProps {
  currentTab: number;
  setCurrentTab(value: number): void;
  tabs: any[];
}

export const OrderWindows = (props: OrderWindowsProps) => {
  const { tabs, currentTab, setCurrentTab } = props;

  return (
    <TabPanelContainer index={currentTab} onChangeIndex={setCurrentTab} disabled>
      {tabs.map((tab, index) => {
        return (
          <OrderWindow value={index} currentValue={currentTab} key={tab.name}>
            {tab.render()}
          </OrderWindow>
        );
      })}
    </TabPanelContainer>
  );
};
